import API from '../api'
import { ConsultationsResponse } from "./consultationsModel"

export const getConsultations = async (request: any) => {
  return (await API.get<ConsultationsResponse>('/web/consultations', {
    params: {
      ...request
    }
  })).data
}